import styled from "styled-components";

import { FlexRow } from "@similarweb/ui-components";


export const HeaderRow = styled(FlexRow)`
    justify-content: right;
    padding: 0 0 12px 8px;
`;

export const CloseButtonContainer = styled(FlexRow)`
    button {
        margin: 0 6px;
    }
`;
export const FiltersContainer = styled(FlexRow)`
    height: 80px;
    align-items: center;
    justify-content: flex-start;
    > * {
        margin-right: 8px;
    }
`;
